import { createSelector } from 'reselect'
import productTypes from 'helpers/enums/productTypes'

const getUserData = state => state.user.data

export default createSelector(
	[getUserData],
	userData => [productTypes.SCHOOL, productTypes.DISTRICT].includes(userData.productId) && userData.firstLogin
)
